<ng-container *ngIf="user$ | async as user">
  <ion-header color="primary">

    <ion-toolbar color="primary" class="header-toolbar" style="padding: 0; --border-width: 0 0;">

      <ion-buttons slot="start">
        <ion-back-button icon="chevron-back-outline" defaultHref="/"></ion-back-button>
      </ion-buttons>

      <ion-title>{{apptitle}}</ion-title>
      <ion-buttons slot="end">
        <!-- <ion-button id="open-user-modal" expand="block" (click)="handelUserModal">
          <ion-icon slot="icon-only" color="secondary" name="person-circle"></ion-icon>
        </ion-button> -->
      </ion-buttons>
    </ion-toolbar>

    <ion-modal #modal trigger="open-user-modal" [canDismiss]="canDismiss" #IonUserModal>
      <ng-template>
        <ion-header>
          <ion-toolbar>
            <ion-title>Perfil</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="modal.dismiss()">
                <ion-icon slot="icon-only" color="primary" name="close-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-list [inset]="true">
            <ion-item color="secondary">
              <ion-label slot="start">Email</ion-label>
              <ion-text slot="end">{{user.email}}</ion-text>
            </ion-item>

          </ion-list>
          <ion-button (click)="logout()" fill="clear" style="width: 100%; ">Logout</ion-button>
<ion-list [inset]="true" style="margin-top: 16px;">
  <ion-item color="secondary">
    <ion-icon name="camera-outline" slot="start"></ion-icon>
    <ion-label>Scan por câmara</ion-label>
    <ion-toggle slot="end" [checked]="cameraScanEnabled$ | async" (ionChange)="onToggleCameraScan($event)"></ion-toggle>
  </ion-item>
</ion-list>

          <div style="text-align: center; padding: 30px; font-size: 10px;">v{{version}}</div>

        </ion-content>
      </ng-template>
    </ion-modal>
  </ion-header>
</ng-container>
